var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2435_146008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 6V16.05",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    fill: "#00000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 23.95V34",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0002 20H23.9502",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.05 20H6",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3799 17.35C13.1899 15.03 15.0199 13.2 17.3299 12.39",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2999 27.6C14.9999 26.78 13.1899 24.96 12.3799 22.65",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6199 22.65C26.8099 24.97 24.9799 26.8 22.6699 27.61",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6602 12.39C24.9702 13.2 26.8002 15.03 27.6102 17.34",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66016 17.34C9.66016 13.05 13.0402 9.66998 17.3302 8.66998",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3502 31.34C13.0502 30.34 9.67016 26.95 8.66016 22.65",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3399 22.66C30.3399 26.95 26.9599 30.33 22.6699 31.33",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6602 8.65997C26.9502 9.65997 30.3302 13.04 31.3302 17.33",
    stroke: "#002554",
    strokeWidth: 1.15,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2435_146008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/Target.849faa3394fcaabedb4347451eeea95d.svg";
export { ForwardRef as ReactComponent };